import { render, staticRenderFns } from "./SubNavLink.vue?vue&type=template&id=68d9c81d&"
import script from "./SubNavLink.vue?vue&type=script&lang=js&"
export * from "./SubNavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports